import { VStack } from '@chakra-ui/react';
import { env } from 'lib/constants/env';

import { Shipping } from './Shipping';
import { Truemed } from './Truemed';

interface ProductCheckmarksProps {
  productId?: string;
  isShippingInfoVisible: boolean;
  isTruemedVisible: boolean;
}

const truemedUrl = env.NEXT_PUBLIC_TRUEMED_QUALIFICATION_URL;
const isTrumedEnabled = typeof truemedUrl === 'string';

export function ProductCheckmarks({
  productId,
  isShippingInfoVisible,
  isTruemedVisible,
}: ProductCheckmarksProps) {
  return (
    <VStack alignItems="flex-start" as="ul" spacing="5xs">
      {isShippingInfoVisible && <Shipping productId={productId} />}
      {isTruemedVisible && isTrumedEnabled && (
        <Truemed truemedUrl={truemedUrl} />
      )}
    </VStack>
  );
}
